module.exports = __webpack_public_path__ + "img/title.20b0a084.png";